let view = null;

export default {
	namespace: 'template-news',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: NewsView } = await import(/* webpackChunkName: "news-view" */ '../../templates/NewsView');
		view = new NewsView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
